import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { UniversalLink } from '@plone/volto/components';
import { useIntl, defineMessages } from 'react-intl';
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardText,
  Accordion,
  AccordionItem,
  AccordionHeader,
  AccordionBody,
} from 'design-react-kit';
import './redazioni_info.scss';
const messages = defineMessages({
  redazioni_locali: {
    id: 'redazioni_locali',
    defaultMessage: 'Informazioni dalle Redazioni locali',
  },
});

function splitArrayInParts(arr, parts) {
  let partSize = Math.floor(arr.length / parts);
  if (arr.length % parts > 0) {
    partSize += 1;
  }
  let split = [];
  if (arr.length <= parts) {
    return [arr];
  }

  for (let i = 0; i < parts; i++) {
    split.push(arr.slice(i * partSize, i * partSize + (partSize - 1)));
  }

  return split;
}

const RERRedazioniInfo = ({ content, className }) => {
  const intl = useIntl();
  const redazioni_infos =
    content?.['@components']?.['redazioni-data']?.items ?? [];

  const split = splitArrayInParts(redazioni_infos, 3);
  const title = intl.formatMessage(messages.redazioni_locali);

  const [open, setOpen] = useState(false);

  return redazioni_infos?.length > 0 ? (
    <div className={cx('redazioni-info', className)}>
      <Accordion>
        <AccordionItem>
          <AccordionHeader
            active={open}
            onToggle={() => {
              setOpen(!open);
            }}
          >
            {title}
          </AccordionHeader>
          <AccordionBody active={open}>
            <Row>
              {split.map((s) => (
                <Col xs={12} lg={4}>
                  <ul aria-label={title} className="lista-redazioni">
                    {s.map((r) => (
                      <li className="redazione">
                        <UniversalLink item={r}>
                          {r.title} ({r.items_total})
                        </UniversalLink>
                      </li>
                    ))}
                  </ul>
                </Col>
              ))}
            </Row>
          </AccordionBody>
        </AccordionItem>
      </Accordion>
    </div>
  ) : (
    <></>
  );
};

RERRedazioniInfo.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
};

export default RERRedazioniInfo;
